import {APP_INITIALIZER, NgModule, Optional, SkipSelf} from '@angular/core';
import {throwIfAlreadyLoaded} from './module-import-guard';
import {HeaderComponent} from './components/header/header.component';
import {FooterComponent} from './components/footer/footer.component';

import {SharedModule} from '../shared/shared.module';
import {NotificationComponent} from './components/notification/notification.component';
import {LoadingSpinnerComponent} from './components/loading-spinner/loading-spinner.component';
import {MatSidenavModule} from '@angular/material/sidenav';
import {SidenavComponent} from './components/sidenav/sidenav.component';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {LeafletModule} from '@asymmetrik/ngx-leaflet';
import {TranslateCompiler, TranslateLoader, TranslateModule} from '@ngx-translate/core';
import {HTTP_INTERCEPTORS, HttpClient} from '@angular/common/http';
import {TranslateMessageFormatCompiler} from 'ngx-translate-messageformat-compiler';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';
import {AppConfigService, initializeAppConfig} from './services/app-config.service';
import {VersionInterceptorService} from './interceptors/version-interceptor.service';
import {LoadingInterceptorService} from './interceptors/loading-interceptor.service';
import {AuthInterceptorService} from './interceptors/auth-interceptor.service';
import {ErrorInterceptorService} from './interceptors/error-interceptor.service';
import {MAT_SELECT_CONFIG} from '@angular/material/select';
import {MatNativeDateModule} from '@angular/material/core';
import {CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { LOCALE_ID } from '@angular/core';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { CustomMatPaginatorIntl } from './services/custom-mat-paginator-intl.service';


@NgModule({
  imports: [
    SharedModule,
    BrowserAnimationsModule,
    LeafletModule,
    MatSidenavModule,
    MatNativeDateModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      },
      compiler: {
        provide: TranslateCompiler,
        useClass: TranslateMessageFormatCompiler
      }
    })
  ],
  declarations: [
    HeaderComponent,
    FooterComponent,
    NotificationComponent,
    LoadingSpinnerComponent,
    SidenavComponent,
  ],
  exports: [
    HeaderComponent,
    FooterComponent,
    SidenavComponent,
    NotificationComponent,
    LoadingSpinnerComponent
  ],
  providers: [
    { provide: LOCALE_ID, useValue: 'en-US' },
    {provide: APP_INITIALIZER, useFactory: initializeAppConfig, deps: [AppConfigService], multi: true},
    {provide: HTTP_INTERCEPTORS, useClass: VersionInterceptorService, multi: true},
    {provide: HTTP_INTERCEPTORS, useClass: LoadingInterceptorService, multi: true},
    {provide: HTTP_INTERCEPTORS, useClass: AuthInterceptorService, multi: true},
    {provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptorService, multi: true},
    {provide: MAT_SELECT_CONFIG, useValue: {disableOptionCentering: true}},
    {provide: MatPaginatorIntl, useClass: CustomMatPaginatorIntl},
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class CoreModule {
  constructor(@Optional() @SkipSelf() parentModule: CoreModule) {
    throwIfAlreadyLoaded(parentModule, 'CoreModule');
  }
}

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/' + AppConfigService.settings.localization.localizationCountry + '_', '.json');
}
